import { pickApiRowValue } from "./qmsApiUtils";
import { getVaultDocumentListId } from "./qmsVaultUtils";

function buildDocumentId(base) {
  return getVaultDocumentListId({
    DocumentTypeAbberiviation: base.documentTypeAbbr,
    DocumentCategoryAbberiviation: base.documentCategoryAbbr,
    DocumentCategoryUniqueNumber: base.documentCategoryUniqueNumber,
    VersionNumber: base.versionNumber,
    DocumentId: base.documentIdRef,
  });
}

function readDocumentBase(row) {
  if (!row || typeof row !== "object") return null;
  return {
    documentIdRef: String(pickApiRowValue(row, "DocumentId", "documentId") || ""),
    documentGroupIdRef: String(pickApiRowValue(row, "DocumentGroupIdRef", "documentGroupIdRef") || ""),
    documentTitle: String(pickApiRowValue(row, "DocumentTitle", "documentTitle") || ""),
    documentUrl: String(pickApiRowValue(row, "DocumentURL", "documentUrl") || ""),
    documentExtension: String(pickApiRowValue(row, "DocumentExtension", "documentExtension") || ""),
    versionNumber: String(pickApiRowValue(row, "VersionNumber", "versionNumber") || ""),
    documentType: String(pickApiRowValue(row, "DocumentType", "documentType") || ""),
    documentTypeAbbr: String(
      pickApiRowValue(row, "DocumentTypeAbbr", "DocumentTypeAbberiviation", "documentTypeAbbr") || "",
    ),
    documentTypeId: String(pickApiRowValue(row, "DocumentTypeId", "documentTypeId") || ""),
    documentCategory: String(pickApiRowValue(row, "DocumentCategory", "documentCategory") || ""),
    documentCategoryAbbr: String(
      pickApiRowValue(
        row,
        "DocumentCategoryAbbr",
        "DocumentCategoryAbberiviation",
        "documentCategoryAbbr",
      ) || "",
    ),
    documentCategoryId: String(pickApiRowValue(row, "DocumentCategoryId", "documentCategoryId") || ""),
    documentCategoryUniqueNumber: String(
      pickApiRowValue(row, "DocumentCategoryUniqueNumber", "documentCategoryUniqueNumber") || "",
    ),
    ownerId: String(pickApiRowValue(row, "OwnerId", "ownerId", "CreatedBy") || ""),
    ownerName: String(pickApiRowValue(row, "OwnerName", "ownerName", "CreatedBy") || ""),
  };
}

export function normalizePendingWorkflowRow(row, datasetKey) {
  const base = readDocumentBase(row);
  if (!base) return null;
  const title = `${base.documentTitle || "Untitled"}${base.documentExtension ? `.${base.documentExtension}` : ""}`;
  return {
    dataset: datasetKey,
    documentIdRef: base.documentIdRef,
    documentId: buildDocumentId(base),
    documentTitle: title,
    documentUrl: base.documentUrl,
    documentExtension: base.documentExtension,
    documentType: base.documentType || "—",
    documentTypeAbbr: base.documentTypeAbbr,
    documentTypeId: base.documentTypeId,
    documentCategory: base.documentCategory || "—",
    documentCategoryAbbr: base.documentCategoryAbbr,
    documentCategoryId: base.documentCategoryId,
    versionNumber: base.versionNumber || "—",
    ownerName: base.ownerName || "—",
    ownerId: base.ownerId,
    assigneeId: String(pickApiRowValue(row, "AssigneeId", "assigneeId") || ""),
    assigneeName: String(pickApiRowValue(row, "AssigneeName", "assigneeName") || "—"),
    sentDate: String(pickApiRowValue(row, "SentDate", "sentDate") || "—"),
    sentAt: pickApiRowValue(row, "SentAt", "sentAt"),
    daysPending:
      pickApiRowValue(row, "DaysPending", "daysPending") != null
        ? Number(pickApiRowValue(row, "DaysPending", "daysPending"))
        : null,
  };
}

export function normalizeTrendDocumentRow(row, datasetKey) {
  const base = readDocumentBase(row);
  if (!base) return null;
  const title = `${base.documentTitle || "Untitled"}${base.documentExtension ? `.${base.documentExtension}` : ""}`;
  const eventAt = pickApiRowValue(row, "EventAt", "eventAt");
  const periodMonth = String(pickApiRowValue(row, "PeriodMonth", "periodMonth") || "");
  return {
    dataset: datasetKey,
    documentIdRef: base.documentIdRef,
    documentId: buildDocumentId(base),
    documentTitle: title,
    documentUrl: base.documentUrl,
    documentExtension: base.documentExtension,
    documentType: base.documentType || "—",
    documentTypeAbbr: base.documentTypeAbbr,
    documentTypeId: base.documentTypeId,
    documentCategory: base.documentCategory || "—",
    documentCategoryAbbr: base.documentCategoryAbbr,
    documentCategoryId: base.documentCategoryId,
    versionNumber: base.versionNumber || "—",
    ownerName: base.ownerName || "—",
    ownerId: base.ownerId,
    eventDate: String(pickApiRowValue(row, "EventDate", "eventDate") || "—"),
    eventAt,
    periodMonth: periodMonth || "—",
    createdAt: eventAt,
  };
}

export function normalizeArchivedDocumentRow(row) {
  const base = readDocumentBase(row);
  if (!base) return null;
  const title = `${base.documentTitle || "Untitled"}${base.documentExtension ? `.${base.documentExtension}` : ""}`;
  const archivedAt = pickApiRowValue(row, "ArchivedAt", "archivedAt");
  return {
    dataset: "archivedDocuments",
    documentIdRef: base.documentIdRef,
    documentId: buildDocumentId(base),
    documentTitle: title,
    documentUrl: base.documentUrl,
    documentExtension: base.documentExtension,
    documentType: base.documentType || "—",
    documentTypeAbbr: base.documentTypeAbbr,
    documentTypeId: base.documentTypeId,
    documentCategory: base.documentCategory || "—",
    documentCategoryAbbr: base.documentCategoryAbbr,
    documentCategoryId: base.documentCategoryId,
    versionNumber: base.versionNumber || "—",
    ownerName: base.ownerName || "—",
    ownerId: base.ownerId,
    archivedDate: String(pickApiRowValue(row, "ArchivedDate", "archivedDate") || "—"),
    archivedAt,
    createdAt: archivedAt,
  };
}

export function dedupeArchivedRows(rows) {
  const seen = new Map();
  (rows || []).forEach((row) => {
    const key = row.documentGroupIdRef || row.documentIdRef;
    if (!key) return;
    const existing = seen.get(key);
    if (!existing || Number(row.versionNumber) > Number(existing.versionNumber)) {
      seen.set(key, row);
    }
  });
  return Array.from(seen.values());
}
